<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Website </vs-th>
                <vs-th> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].username">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].website }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Striped</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table stripe :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Website </vs-th>
                <vs-th> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].username">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].website }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">State</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table  :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Website </vs-th>
                <vs-th> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
               <vs-tr :state="indextr == 2 || indextr == 5?'success':indextr == 6?'danger':null" :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].username">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].website }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Pagination</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table max-items="3" pagination :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Website </vs-th>
                <vs-th> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
               <vs-tr  :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td :data="data[indextr].email">
                    {{ data[indextr].email }}
                  </vs-td>

                  <vs-td :data="data[indextr].username">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>

                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].website }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Single Selected</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table     v-model="selected"
      @selected="handleSelected"
      @dblSelection="doubleSelection" :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Website </vs-th>
                <vs-th> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
               <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}}
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].username}}
          </vs-td>

          <vs-td :data="data[indextr].website">
            {{data[indextr].website}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].id}}
          </vs-td>
        </vs-tr>
              </template>
            </vs-table>
            <pre>{{ selected }}</pre>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Multiple Selected</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-table multiple    v-model="selected" :data="users">
              <template slot="thead">
                <vs-th> Email </vs-th>
                <vs-th> Name </vs-th>
                <vs-th> Website </vs-th>
                <vs-th> Nro </vs-th>
              </template>

              <template slot-scope="{ data }">
               <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}}
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].username}}
          </vs-td>

          <vs-td :data="data[indextr].website">
            {{data[indextr].website}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].id}}
          </vs-td>
        </vs-tr>
              </template>
            </vs-table>
            <pre>{{ selected }}</pre>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
     handleSelected(tr) {
      this.$vs.notify({
        title:`Selected ${tr.username}`,
        text:`Email: ${tr.email}`
      })
    },
    doubleSelection(tr) {
      this.$vs.notify({
        title:`Double Selection ${tr.username}`,
        text:`Email: ${tr.email}`,
        color: 'success'
      })
    }
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({
       selected:[],
    users: [
      {
        id: 1,
        name: "Leanne Graham",
        username: "Bret",
        email: "Sincere@april.biz",
        website: "hildegard.org",
      },
      {
        id: 2,
        name: "Ervin Howell",
        username: "Antonette",
        email: "Shanna@melissa.tv",
        website: "anastasia.net",
      },
      {
        id: 3,
        name: "Clementine Bauch",
        username: "Samantha",
        email: "Nathan@yesenia.net",
        website: "ramiro.info",
      },
      {
        id: 4,
        name: "Patricia Lebsack",
        username: "Karianne",
        email: "Julianne.OConner@kory.org",
        website: "kale.biz",
      },
      {
        id: 5,
        name: "Chelsey Dietrich",
        username: "Kamren",
        email: "Lucio_Hettinger@annie.ca",
        website: "demarco.info",
      },
      {
        id: 6,
        name: "Mrs. Dennis Schulist",
        username: "Leopoldo_Corkery",
        email: "Karley_Dach@jasper.info",
        website: "ola.org",
      },
      {
        id: 7,
        name: "Kurtis Weissnat",
        username: "Elwyn.Skiles",
        email: "Telly.Hoeger@billy.biz",
        website: "elvis.io",
      },
      {
        id: 8,
        name: "Nicholas Runolfsdottir V",
        username: "Maxime_Nienow",
        email: "Sherwood@rosamond.me",
        website: "jacynthe.com",
      },
      {
        id: 9,
        name: "Glenna Reichert",
        username: "Delphine",
        email: "Chaim_McDermott@dana.io",
        website: "conrad.com",
      },
      {
        id: 10,
        name: "Clementina DuBuque",
        username: "Moriah.Stanton",
        email: "Rey.Padberg@karina.biz",
        website: "ambrose.net",
      },
    ],
  }),
};
</script>